import { DefaultTheme } from "styled-components"

export const lightTheme: DefaultTheme = {
  textColor: "#130304",
  lightTextColor: "#ADADAD",
  backgroundColor: "#FFFFFF",
  placeholderColor: "#B0B0B0",
  primaryColor: "#DA2020",
}
